<script>
import { mapActions, mapGetters } from "vuex";
// import ApplicationAdd from "../../components/ApplicationAdd.vue";
import appStatuses from "../../service/app-statuses.js";

import Application from "../../components/copy_old/index.vue";
import Perevod from "../../components/perevod/perevod.vue";
import Secondspes from "~/src/components/secondspecifity/secondspes.vue";

export default {
  components: { Application, Perevod, Secondspes },

  data: () => ({
    appType: null,
  }),

  created() {
    this.INIT_APPLICATION();
  },

  computed: {
    ...mapGetters("application", ["GET_APPLICATION"]),
    application: (vm) => vm.GET_APPLICATION,
    isReadonly() {
      const status = this.application.status;
      return status != "DRAFT" && status != "REJECTED";
    },
    isAccepted() {
      const status = this.application.status;
      return status == "ACCEPTED";
    },
    isSubmitted() {
      const status = this.application.status;
      return status == "SUBMITTED";
    },
    isRejected() {
      const status = this.application.status;
      return status == "REJECTED";
    },

    applicationStatus() {
      const status =
        appStatuses.find((x) => x.id == this.application.status) || {};

      return {
        name: status[`name-${this.$i18n.locale}`],
        color: color(status.id),
      };

      function color(statusName) {
        switch (statusName) {
          case "ACCEPTED":
            return "#26d317";
          case "PASSED":
            return "#032f66";
          case "REJECTED":
            return "#Fb0607";
          case "SUBMITTED":
            return "#d8d813";
          case "FAILED":
            return "#Fb1e06";
          default:
            return null;
        }
      }
    },

    empInitials() {
      const n = ((this.application && this.application.referralEmployee && this.application.referralEmployee.fullName) || "").trim();
      if (!n) return "?";
      const p = n.split(/\s+/);
      return ((p[0] ? p[0][0] : "") + (p[1] ? p[1][0] : "")).toUpperCase() || "?";
    },
  },

  methods: {
    ...mapActions("application", [
      "INIT_APPLICATION",
      "SET_APP_TYPE",
      "SET_APPLICATION",
    ]),

    onChangeApp() {
      this.$nextTick(() => {
        this.SET_APPLICATION(this.application);
      });
    },

    async onApplyAppType() {
      if (!this.$refs.form.validate()) return;
      const status = await this.SET_APP_TYPE({ type: this.appType });
      if (status) {
        this.application.typeAbiturient = this.appType;
        window.location.reload();
      }
    },
  },
};
</script>

<template>
  <div>
    <div
      v-if="application && application.referralEmployee"
      class="emp-contact"
    >
      <div class="emp-contact__label">{{ $t('Your admission contact') }}</div>
      <div class="emp-contact__body">
        <div class="emp-contact__avatar">{{ empInitials }}</div>
        <div class="emp-contact__info">
          <div class="emp-contact__name">{{ application.referralEmployee.fullName }}</div>
          <div class="emp-contact__pos" v-if="application.referralEmployee.position">
            {{ application.referralEmployee.position }}
          </div>
        </div>
        <a
          v-if="application.referralEmployee.phone"
          class="emp-contact__phone"
          :href="'tel:' + application.referralEmployee.phone"
        >
          <v-icon size="18">mdi-phone</v-icon>
          {{ application.referralEmployee.phone }}
        </a>
      </div>
    </div>

    <v-container
      v-if="!application?.typeAbiturient"
      fluid
      class="-radio-button-wrap"
    >
      <v-form ref="form" lazy-validation onSubmit="return false;">
        <h2>{{ $t("ariza shakli") }}</h2>
        <v-radio-group :rules="[$rules.required]" v-model="appType">
          <v-radio class="-rbutton-status" value="MASTER">
            <template v-slot:label>
              <strong class="text-success">Magistratura</strong>
            </template>
          </v-radio>
          <v-radio class="-rbutton-status" value="perevod">
            <template v-slot:label>
              <strong class="text-primary">O`qishni ko`chirish</strong>
            </template>
          </v-radio>
          <v-radio class="-rbutton-status" value="second_spes">
            <template v-slot:label>
              <strong class="text-primary">Ikkinchi mutaxassislik</strong>
            </template>
          </v-radio>
        </v-radio-group>
      </v-form>

      <v-btn @click="onApplyAppType"> Tasdiqlash </v-btn>
    </v-container>

    <template v-else-if="application.typeAbiturient == 'ABITURIENT'">
      <template v-if="isAccepted || isRejected || isSubmitted">
        <div class="-status-wrap">
          <div
            class="-status"
            :style="{
              backgroundColor: applicationStatus.color,
              textAlign: 'center',
            }"
          >
            {{ $t("Status") }}: {{ applicationStatus.name }}
          </div>
        </div>
      </template>
      <Application :isReadonly="isReadonly" />
    </template>
    <template v-else-if="application.typeAbiturient == 'PEREVOD'">
      <template v-if="isAccepted || isRejected || isSubmitted">
        <div class="-status-wrap">
          <div
            class="-status"
            :style="{
              backgroundColor: applicationStatus.color,
              textAlign: 'center',
            }"
          >
            {{ $t("Status") }}: {{ applicationStatus.name }}
          </div>
        </div>
      </template>
      <Perevod :isReadonly="isReadonly" />
    </template>
    <template v-else-if="application.typeAbiturient == 'SECOND_SPES'">
      <template v-if="isAccepted || isRejected || isSubmitted">
        <div class="-status-wrap">
          <div
            class="-status"
            :style="{
              backgroundColor: applicationStatus.color,
              textAlign: 'center',
            }"
          >
            {{ $t("Status") }}: {{ applicationStatus.name }}
          </div>
        </div>
      </template>
      <Secondspes :isReadonly="isReadonly" />
    </template>
    <template v-else-if="application.typeAbiturient == 'MASTER'">
      <template v-if="isAccepted || isRejected || isSubmitted">
        <div class="-status-wrap">
          <div
            class="-status"
            :style="{
              backgroundColor: applicationStatus.color,
              textAlign: 'center',
            }"
          >
            {{ $t("Status") }}: {{ applicationStatus.name }}
          </div>
        </div>
      </template>
      <Secondspes :isReadonly="isReadonly" />
    </template>
  </div>
</template>

<style lang="scss" scoped>
.emp-contact {
  position: relative;
  max-width: 760px;
  margin: 18px auto 4px;
  background: #fff;
  border: 1px solid rgba(15, 26, 46, 0.1);
  border-radius: 16px;
  padding: 16px 18px;
  box-shadow: 0 4px 18px rgba(15, 26, 46, 0.06);
  overflow: hidden;
}
.emp-contact::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(180deg, #ffce4a, #f4a915);
}
.emp-contact__label {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: #b07d12;
  margin-bottom: 12px;
}
.emp-contact__body {
  display: flex;
  align-items: center;
  gap: 14px;
}
.emp-contact__avatar {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  font-weight: 800;
  font-size: 17px;
  color: #1a1304;
  background: linear-gradient(145deg, #ffe07a, #f4a915);
}
.emp-contact__info {
  flex: 1;
  min-width: 0;
}
.emp-contact__name {
  font-weight: 800;
  font-size: 17px;
  color: #0f1a2e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.emp-contact__pos {
  font-size: 13px;
  color: #6b7891;
  margin-top: 2px;
}
.emp-contact__phone {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #0c1322;
  color: #ffce4a;
  text-decoration: none;
  padding: 9px 14px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 14px;
  transition: transform 0.15s ease;
}
.emp-contact__phone:hover {
  transform: translateY(-1px);
}
.emp-contact__phone .v-icon {
  color: #ffce4a !important;
}
@media (max-width: 560px) {
  .emp-contact__body {
    flex-wrap: wrap;
  }
  .emp-contact__phone {
    width: 100%;
    justify-content: center;
  }
}
.theme--dark .emp-contact {
  background: #161922;
  border-color: rgba(255, 255, 255, 0.08);
}
.theme--dark .emp-contact__name {
  color: #eef1f7;
}
.theme--dark .emp-contact__pos {
  color: #8b94a8;
}

.-status-wrap {
  display: flex;
  justify-content: center;
  padding-top: 30px;
  padding-bottom: 10px;

  .-status {
    max-width: 360px;
    padding: 8px 5px;
    border-radius: 10px;
    width: 100%;
    text-align: center;
    cursor: default;
    font-size: 20px;
    color: white;
    margin-top: 30px;
  }
}

.-radio-button-wrap {
  display: grid;
  justify-content: center;
  padding-top: 30px;
  padding-bottom: 10px;

  .-rbutton-status {
    max-width: 360px;
    padding: 8px 5px;
    border-radius: 10px;
    width: 100%;
    text-align: center;
    cursor: default;
    font-size: 20px;
    color: white;
  }
}

//
</style>
